<template>

    <b-button type="submit" variant="primary" :disabled="disabled">
        <b-spinner v-if="disabled" style="vertical-align:middle;" small></b-spinner>
        <slot></slot>
    </b-button>

</template>

<script>

export default {
    name: 'LoadingButton',
    props: {
        disabled: Boolean
    }
}
</script>
